import { toUrlParameters } from './util';
export class SessionRemoteRepository {
    constructor(fetcher, contextId) {
        this.fetcher = fetcher;
        this.contextId = contextId;
    }
    async endSession(currentSession) {
        await this.fetcher.fetchPostJson(`${SessionRemoteRepository.SESSIONS_PATH}/${currentSession.id}/end`, undefined, undefined, true);
    }
    sendCloseBeacon(currentSession) {
        this.fetcher.beaconPostJson(`${SessionRemoteRepository.SESSIONS_PATH}/${currentSession.id}/close-beacon`);
    }
    async fetchSessions(active) {
        const params = {
            contextId: this.contextId,
            active: active
        };
        const responses = await this.fetcher.fetchGetJson(`${SessionRemoteRepository.SESSIONS_PATH}?${toUrlParameters(params)}`);
        return responses.map(response => SessionRemoteRepository.mapResponseToSession(response));
    }
    async fetchSession(sessionId) {
        const response = await this.fetcher.fetchGetJson(`${SessionRemoteRepository.SESSIONS_PATH}/${sessionId}`);
        return SessionRemoteRepository.mapResponseToSession(response);
    }
    async fetchSessionLiveness(sessionId) {
        const response = await this.fetcher.fetchGetJson(`${SessionRemoteRepository.SESSIONS_PATH}/${sessionId}/liveness`);
        return SessionRemoteRepository.mapResponseToSessionLivenessResponse(response);
    }
    static mapResponseToSession(response) {
        return {
            id: response.id,
            username: response.username,
            locale: response.locale,
            roles: response.roles,
            createDate: new Date(response.createDate),
        };
    }
    static mapResponseToSessionLivenessResponse(response) {
        return {
            id: response.id,
            username: response.username,
            locale: response.locale,
            roles: response.roles,
            createDate: new Date(response.createDate),
            endDate: response.endDate ? new Date(response.endDate) : undefined,
        };
    }
}
SessionRemoteRepository.SESSIONS_PATH = '/api/sessions';
